<template>
  <div class="grid-cell selected-tiem">
    <ejs-radiobutton
      v-model="item"
      name="custom"
      css-class="e-primary"
      @change="selectTemplate"
    />
  </div>
</template>

<script>
export default {
  data () {
    return {
      item: null
    }
  },
  methods: {
    selectTemplate () {
      this.$store.commit('SET_SELECTED_TEMPLATE', this.data)
    }
  }
}
</script>
<style scoped>
  .selected-tiem {
    text-align: center;
  }
</style>
